import { AncillaryContent } from '@com-delta-idp/mnx-capability-trip-management-ui';
import { AncillaryLinks } from '@com-delta-idp/mnx-sitewide-shared-utils';
import { COUNT } from '../constants/my-trip-constants';

export const getAncillaryContent = (
  links: AncillaryLinks,
  count: string
): AncillaryContent => {
  const data = { ...links } as AncillaryContent;
  data.viewAllTrips = links.viewAllTrips.replace(COUNT, '(' + count + ')');
  data.hasTrips = Number(count) > 0 ? true : false;
  return data;
};
